var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background-color":"#58727E"}},[_c('Header'),_c('div',{staticStyle:{"margin-top":"100px"}},[_c('RegistroFichas')],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }